export const iconFontAwesomeSecurityHouseLock = (
	<i className="fa-solid fa-house-lock"></i>
);
